import { Link } from 'gatsby'
import styled from 'styled-components'

export const HeaderContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  padding: 32px 36px 20px;
  align-items: center;

  & a {
    text-decoration: none;
  }

  @media (max-width: 1366px) {
    grid-template-columns: 0 1fr auto;
  }

  @media (max-width: 767px) {
    grid-template-columns: 1fr auto 1fr;
    padding: 14px 16px;
  }
`

export const DesktopMenuContainer = styled.div`
  font-family: VerlagBold;
  font-size: 1.4rem;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  justify-self: ${({ rightAlign }) => (rightAlign ? 'right' : 'left')};
  gap: 12px;
  color: var(--mediumGrey);
  & a {
    color: var(--mediumGrey);
    &:hover {
      color: var(--orange);
    }
  }
  @media (max-width: 767px) {
    display: none;
  }
`

export const HamburgerMenu = styled.button`
  display: none;
  & img {
    width: 18px;
  }
  @media (max-width: 767px) {
    display: inherit;
  }
`

export const MainTitle = styled.img`
  width: 550px;
  margin: 0 80px;

  @media (max-width: 1366px) {
    margin-left: 0;
    justify-self: start;
  }

  @media (max-width: 1020px) {
    width: calc(100vw - 303px - 72px - 100px);
  }

  @media (max-width: 767px) {
    width: 70vw;
    justify-self: center;
    margin: 0;
  }
`

export const MenuItem = styled(Link)`
  && {
    color: ${({ selected }) => (selected ? 'var(--darkGrey)' : 'inherit')};
    text-decoration: ${({ selected }) => (selected ? 'underline' : 'inherit')};
  }
`
